export const USER_INPUT_PREVIEW_SIGNATURE_REQUEST = 'USER_INPUT_PREVIEW_SIGNATURE_REQUEST';
export const USER_INPUT_PREVIEW_SIGNATURE_SUCCESS = 'USER_INPUT_PREVIEW_SIGNATURE_SUCCESS';
export const USER_INPUT_PREVIEW_SIGNATURE_FAIL = 'USER_INPUT_PREVIEW_SIGNATURE_FAIL';